<!--
Author: TangChen
Date: 2018-12-24
Desc: 私募基金、专户理财持有展示
 -->
<template>
    <div :class="'bizcomp-private-fund bizcomp ' + className">
        <comp-title :title="title" />
        <div class="fund-market">
            <fund-risk-filter v-if="compCate!=='1'" :qryall="qryallfund" v-on:qry-change="qryChange" />
            <el-table :data="fundAll" style="width: 100%" :show-header="false">
                <el-table-column label="基金信息" width="1000">
                    <template slot-scope="scope">
                        <el-row class="fund-list">
                            <el-col :span="24" class="fund-tit">
                                <span>{{ scope.row.fundname+'('+(scope.row.fundcode === "515981" ? "515980" : scope.row.fundcode)+')' }}<i
                                    class="risk"
                                    :class="$util.riskCla(scope.row.risklevel)"
                                >{{ $cache.getDict('110143',scope.row.risklevel)+'风险' }}</i></span>
                            </el-col>
                            <el-col :span="compCate!=='1'?5:6">
                                <span class="big" :class="scope.row.annualincome>0?'add':(scope.row.annualincome<0?'reduce':'')">{{ $util.fmtNum(scope.row.annualincome) }}%</span>
                                <p>预计年化收益</p>
                            </el-col>
                            <el-col :span="compCate!=='1'?5:6">
                                <span>{{ scope.row.deadline.trim()?$cache.getDict('150071',scope.row.deadline):'--' }}</span>
                                <p>投资期限</p>
                            </el-col>
                            <el-col :span="compCate!=='1'?5:6">
                                <span>{{ $util.fmtNum(parseFloat(scope.row.minamount)/10000) }}</span>
                                <p>投资起点(万元)</p>
                            </el-col>
                            <el-col :span="compCate!=='1'?4:6">
                                <span>{{ $cache.getDict('100017',scope.row.risklevel) }}</span>
                                <p>适合人群</p>
                            </el-col>
                            <el-col v-if="compCate!=='1'" :span="5">
                                <p style="padding: 6px 0;">
                                    <el-progress
                                        :percentage="Number(scope.row.soldprogress*100)"
                                        :stroke-width="10"
                                        color="#4fd06a"
                                        :show-text="false"
                                    />
                                </p>
                                <p>已完成：<span>{{ Number($util.fmtNum(scope.row.soldprogress*100)) }}%</span></p>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column label="基金操作" prop="fundcode" align="center" min-width="158px">
                    <template slot-scope="scope">
                        <el-tooltip
                            v-if="scope.row.isBuy || scope.row.fundbizflag.indexOf('k') === -1 || $cache.getUser().certificatetype !== '0'"
                            class="item"
                            effect="info"
                            :content="$cache.getUser().certificatetype !== '0' ? '非身份证用户无法购买' : '已售罄或未开通购买'"
                            placement="left"
                        >
                            <el-button type="lock" size="small">
                                {{ compCate==='1'?'追加':'立即' }}购买
                            </el-button>
                        </el-tooltip>
                        <el-button v-else type="yellow" size="small" v-on:click="fundBuy('20,22',scope.row)">
                            {{ compCate==='1'?'追加':'立即' }}购买
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="allPage > pagecount" class="page-box">
                <el-pagination
                    :page-size="Number(pagecount)"
                    :current-page.sync="curPage"
                    background
                    layout="prev, pager, next"
                    :total="Number(allPage)"
                    v-on:current-change="dataReset"
                />
            </el-row>
        </div>
        <msg-dialog :dialog="dialog" :private-info="privateInfo" />
        <!-- <el-button type="yellow" size="small" v-on:click="test()">
            测试
        </el-button> -->
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import msgDialog from "@/components/misc/msgDialog";
import fundRiskFilter from "@/components/form/fundRiskFilter";
export default {
    name: "PrivateFund",
    components: {
        msgDialog,
        fundRiskFilter
    },
    mixins: [mixin],
    data () {
        return {
            fundAll: [],
            allPage: "0", // 总页数
            curPage: 1,
            dialog: false,
            pagecount: "", // 分页条数
            pageoffset: "0", // 起始页
            qryallfund: "", // 适当性过滤字段
            queryFind: null,
            acctStatus: {},
            privateInfo: {
                tit: "合格投资者确认",
                msg: "此产品为百万起投的专户理财产品，仅面向合格投资者。请确认是否符合条件。按照《私募投资基金监督管理暂行办法》" +
                    "第十二条规定私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100 万元且" +
                    "符合下列相关标准的单位和个人:<br>净资产不低于1000 万元的单位；<br>金融资产不低于300 万元或者最近三年个人年均收入不" +
                    "低于50 万元的个人。 前款所称金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。"
            }
        };
    },
    mounted () {
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
        // this.getAcctStatus()
        this.getPrivate();
    },
    methods: {
        /* test () {
            this.$util.request("acct/cust/contract", {}, "POST", false).then(res => {
                if (res.data) {
                    this.$util.newWinOpenSign(JSON.stringify(res.data[0]));
                }
            });
        }, */
        fundBuy (way, val) {
            // 普通购买/定投
            val.proto = "buy";
            this.$util.fundRiskCheck(this, val, res => {
                if (res) {
                    const _url = "privatebuy";
                    const _x = Object.assign({}, res, { way: way });
                    sessionStorage.setItem(_url, JSON.stringify(_x));
                    this.$router.push({ name: _url, query: { fundcode: res.fundcode } });
                }
            });
        },
        // 改变风险过滤规则
        qryChange (val) {
            this.qryallfund = val;
            this.pageoffset = "0";
            this.curPage = 1;
            this.doAction();
        },
        dataReset (val) {
            this.pageoffset = val - 1;
            this.doAction();
        },
        doAction () {
            const _this = this;
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getPrivate();
            }, 100);
        },
        getPrivate () {
            const _this = this;
            const _x = {
                qryallfund: this.qryallfund,
                pagecount: this.pagecount,
                pageoffset: (this.pageoffset * this.pagecount).toString()
            };
            this.$util.request("pef/trade/prdlist", _x, "GET", false).then(res => {
                if (res.data) {
                    this.getNewFund(res.data[0]);
                    this.qryallfund = res.data[1][0].qryallfund;
                    const info = _this.$cache.getUser();
                    info.qryallfund = _this.qryallfund;
                    _this.$store.dispatch("setInfo", info);
                    this.allPage = res.alllength;
                }
            });
        },
        // 添加判定参数
        getNewFund (data) {
            const _arr = [];
            data.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index + 1;
                _x.isBuy = this.$util.checkBuy(_x.fundstatus);
                _arr.push(_x);
            });
            this.fundAll = _arr;
        },
        // 获取投资者状态
        getAcctStatus () {
            this.$util.request("pef/investor/type").then(res => {
                if (res.data) {
                    this.dialog = true;
                }
            });
        }
    }
};
</script>
